module.exports = __webpack_public_path__ + "img/reg-complete-icon.0ead6ddd.png";